// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes an existing file from a project.
 *
 * @param projectKey - The key of the project.
 * @param fileKey - The key of the file.
 */
export async function deleteProjectFile(projectKey: string, fileKey: string) {
  const path = `/v1/project/${projectKey}/file/${fileKey}`;
  const response = await api.delete(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteProjectFile',
    endpoint: path,
  });
}
